<template>	
    <b-modal :id="ModalId" size="md" centered scrollable  :title="TitleWindow" @shown="onShown" @ok="this.emitEventOK" @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 
        <b-row>
          <b-col lg="12" md="12" sm="12">
              <MdEdit 
              v-bind:Label="'To'"
              v-bind:Name="'to'"
              v-bind:TypeProp="'text'"                      
              v-model="modelTo"
              v-bind:isRequired="true"
              v-bind:isValid="isValidTo"
              ref="mailTo"
              v-bind:Id="'mailTo'"
              v-bind:Placeholder = "placeholder"            
            />   
          </b-col> 
      </b-row>
      <b-row>
          <b-col md="12" lg="12" sm="12">
            <MdEdit 
                v-bind:Label="'CC'"
                v-bind:TypeProp="'text'"             
                v-bind:Name="'cc'"
                v-model="modelCC"
                v-bind:Placeholder = "placeholder">                                 
            </MdEdit>
        </b-col>   
      </b-row>
      <b-row>
          <b-col lg="12" md="12" sm="12">
            <MdEdit 
                v-bind:Label="'Subject'"
                v-bind:Name="'subject'"
                v-bind:TypeProp="'text'"                      
                v-model="modelSubject"/>   
          </b-col> 
      </b-row>
      <b-row>
          <b-col lg="12" md="12" sm="12">
            <MdMemo
                v-bind:Name="'body'"
                v-bind:Rows="'5'"
                v-bind:MaxRows="'250'"           
                v-model="modelBody"
            />   
          </b-col> 
      </b-row>
    </b-modal>     

</template>

<script>
import DBFunctions from '@/common/DBFunctions.js'

export default {
  name: 'ModalSendMail',
  components: { },
    props: {     
     TitleWindow:String,
     ModalId: String,
     Subject: String,
     GroupCreationId: String,
     Version: Number,
     URL: String,
     Filename: String,
     To: String,
     Body: String,
     Cc: String
   },
    mixins: [DBFunctions],
    data() {
		return {
            modelTo: '',
            modelCC: '',
            modelSubject: this.Subject,
            modelBody: '',
            isValidTo: true,
            placeholder: "user1@domain.com, user2@domain.com"  
        }
    },

watch: {
    Subject(anew) {
      this.modelSubject = anew
    },
    To(anew) {
      this.modelTo = anew
    },
    Cc(anew) {
      this.modelCC = anew
    },
    Body(anew) {
      this.modelBody = anew
    }
},

methods:{


    validate_entries() {
         this.isValidTo = this.modelTo.length > 5  ? true : false
         return this.isValidTo
    },


    emitEventCancel(){

    }, 

    emitEventOK(evt){
        if (this.validate_entries()) {
            this.$emit('ModalClickOk', this.modelTo, this.modelCC, this.modelSubject, this.modelBody);
        } else {
            this.$refs.mailTo.setFocus()
            evt.preventDefault();
        }         
            
    },

    async onShown(){
      this.$refs.mailTo.setFocus()      
    },
},

mounted() {  

},

created(){ 
    
},

beforeDestroy () {     

},
	
}
</script>


